module.exports = __webpack_public_path__ + "img/holding-icon.a4e72a1b.svg";